import { EmailAddressHint } from "@/models/api/mail/EmailAddressHint";
import { EMAIL_ADDRESS_TYPE } from "@/static/emailAddressTypes";
import { Expose } from "class-transformer";
import { IsBoolean, IsEnum, IsOptional, IsString } from "class-validator";

export class EmailAddress extends EmailAddressHint {
  @IsOptional()
  @IsBoolean()
  @Expose()
  isSelected = false;
  @IsEnum(EMAIL_ADDRESS_TYPE)
  @Expose()
  typeEmailAddress!: EMAIL_ADDRESS_TYPE;
  @IsOptional()
  @IsString()
  @Expose()
  comment!: string | null;
}
